module.exports = __webpack_public_path__ + "img/E096.60687011.svg";